export const PICKUP_POINT_ERROR_CODES = [
  'PICKUP_POINT_NOT_FOUND',
  'PICKUP_POINT_INACTIVE',
  'PICKUP_POINT_NOT_AVAILABLE',
  'PICKUP_POINT_ZONE_MISMATCH',
  'PUP_EXTERNAL_ID_REQUIRED',
] as const;

export type PickupPointErrorCode = (typeof PICKUP_POINT_ERROR_CODES)[number];

export const isPickupPointErrorCode = (
  code: string,
): code is PickupPointErrorCode =>
  PICKUP_POINT_ERROR_CODES.includes(code as PickupPointErrorCode);
